import {Component, useState} from "react";
import {Server} from "./Server";
import {ServerSelector} from "./ServerSelector";
import styled from "styled-components";


export const Ping = ({pingMs}) => {
    const color =
        pingMs <= 300 ? '#36D750'
            : pingMs <= 1000 ? 'orange'
                : 'red';
    return (
        <div style={{gap: 6, display: 'flex', alignItems: 'center'}}>
            <span style={{width: 6, height: 6, backgroundColor: color, borderRadius: "50%"}}/>
            <p style={{color: "#919192"}}>{pingMs}ms</p>
        </div>
    )
}

export const ServerSelectorBtn = (
    {
        servers,
        activeServerId,
        setShowServerSelector,
    }
) => {

    const activeServer = servers.find(server => server.server_id === activeServerId);


    switch (activeServer.ping) {
        case activeServer.ping < 100:
            return "green";
    }
    return (
        <ContainerVPN onClick={() => setShowServerSelector(prev => !prev)}>
            <Server server={activeServer} isBtn={true}/>
        </ContainerVPN>


    )
}

export const ContainerVPN = styled.div`
        background-color: #232425;
        border-radius: 8px;
        border: 1px solid #2E2F30;
        //padding: 16px;
        font-family: "VK Sans Display", sans-serif;
    `
